import { StylesSxProps } from "./custom_style";

export const styles: StylesSxProps = {
  mainContentContainer: {
    pt: 5,
    pb: 10,
    display: "flex",
    justifyContent: "center",
  },
};
